export enum AuthEnum {
  LOGIN = "auth/login",
  TOKEN = "auth/token",
  REFRESH_TOKEN = "auth/refreshToken",
  REMEMBER = "auth/remember",
  SESSION = "auth/session",
  USER = "auth/user",
  ROL = "auth/roles",
}

// Duración de la sesión del front: con "Recordarme" 7 días, sin él 1 hora. En
// ambos casos se renueva con cada petición al API (caduca por inactividad).
export const SESSION_DURATION_MS = {
  remember: 7 * 24 * 60 * 60 * 1000,
  default: 60 * 60 * 1000,
};

export const getSessionExpiration = (remember: boolean): string =>
  new Date(
    Date.now() +
      (remember ? SESSION_DURATION_MS.remember : SESSION_DURATION_MS.default)
  ).toISOString();

// Evento global que emite apiFetch cuando la sesión ya no se puede renovar
// (refresh token caducado/invalidado o sesión inactiva). Router lo escucha
// para cerrar la sesión y volver al login.
export const AUTH_SESSION_EXPIRED_EVENT = "auth/sessionExpired";

export type AuthRolType = "channel" | "brand" | "admin" | undefined | null;

export interface AuthProps {
  isLoggedIn: boolean;
  token: string;
  user: any;
  rol: AuthRolType[];
}

export interface AuthDispatchProps extends AuthProps {
  dispatch: React.Dispatch<any>;
}
